<section class="auth-wrapper">
  <img class="logo" src="assets/images/svg/report-logo.svg" alt="AYEN-Logo" />
  <router-outlet></router-outlet>
</section>
